import { Pagination } from "services/search";
import {
  VehicleServices,
  VehicleServicesEditFormValues,
  VehicleServicesRow,
} from "./types";
import {
  transformVehicleServices,
  transformVehicleServicesOnCreate,
  transformVehicleServicesOnUpdate,
  transformVehicleServicesRow,
} from "./transformations";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
 CALCULATION VEHICLE SERVICES SEARCH
-----------------------------------------------------------------------------------------*/

export const getVehicleServicesAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<VehicleServicesRow>> => {
  let path = `/v1/expenses/service?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformVehicleServicesRow);
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE SERVICES - BY ID
-----------------------------------------------------------------------------------------*/
export const getVehicleServiceAPI = async (
  id: string
): Promise<VehicleServices> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/service/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleServices(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE SERVICES - CREATE
-----------------------------------------------------------------------------------------*/
export const createVehicleServiceAPI = async (
  formValues: VehicleServicesEditFormValues
): Promise<VehicleServices> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/service/",
      method: "POST",
      body: transformVehicleServicesOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Servis je uspješno kreirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleServices(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE SERVICES - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateVehicleServiceAPI = async (
  id: string,
  formValues: VehicleServicesEditFormValues
): Promise<VehicleServices> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/service/${id}`,
      method: "PUT",
      body: transformVehicleServicesOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Servis je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleServices(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - VEHICLE SERVICES - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteVehicleServicesAPI = async (
  id: string
): Promise<VehicleServices> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/service/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Servis je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformVehicleServices(response.data);
};
